import { Box } from "@mui/material";
import TrashScheduleTable from "./table/TrashScheduleTable";

const TrashSchedule = () => {
  return (
    <Box>
      <TrashScheduleTable />
    </Box>
  );
};

export default TrashSchedule;
